module.exports = __webpack_public_path__ + "0.ee4ce4b2e29a9f358e00.worker.js"